//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

const getType = require("../../style-spec/util/get_type");
const Color = require("../../style-spec/util/color");
const scaleTypes = ["identity", "exponential", "interval", "categorical"];
const defaultScale = "identity";
const defaultColor = [0, 0, 0, 255];
const { HTMLImageElement, HTMLCanvasElement, HTMLVideoElement, ImageData } = require("../../util/window");

const isNumber = function(value) {
    return value === 0 || Number(value);
};

const types = {
    identity: evaluateIdentityFunction,
    exponential: evaluateExponentialFunction,
    interval: evaluateIntervalFunction,
    categorical: evaluateCategoricalFunction,
};
function handlePaint(paint) {
    if (getType(paint) === "string") {
        return parseLercColor(paint);
    } else if (getType(paint) === "object") {
        if (!oneOf(paint.type, scaleTypes, defaultScale)) throw Error(`paint type should be oneof ${scaleTypes}`);
        return {
            type: paint.type,
            stops: paint.stops.map(([pos, color]) => [pos, parseLercColor(color)]),
            default: parseLercColor(paint.default) || defaultColor,
        };
    }
}
function parseLercColor(input) {
    return Color.parseLercColor(input);
}
function getColor(paint, input) {
    if (!isNumber(input)) {
        return "rgba(0,0,0,0)";
    }
    const fun = types[paint.type];
    if (fun) return fun(paint, input, paint.stops);
    else return paint;
}
function evaluateCategoricalFunction(parameters, input) {
    const evaluated = parameters.stops[input]; // Enforce strict typing on input
    return coalesce(evaluated, parameters.default);
}

function evaluateIntervalFunction(parameters, input) {
    // Edge cases
    if (getType(input) !== "number") return coalesce(parameters.default);
    const n = parameters.stops.length;
    if (n === 1) return parameters.stops[0][1];
    if (input <= parameters.stops[0][0]) return parameters.stops[0][1];
    if (input >= parameters.stops[n - 1][0]) return parameters.stops[n - 1][1];

    const index = findStopLessThanOrEqualTo(parameters.stops, input);

    return parameters.stops[index][1];
}

function evaluateExponentialFunction(parameters, input) {
    // const base = parameters.base !== undefined ? parameters.base : 1;

    // Edge cases
    if (getType(input) !== "number") return coalesce(parameters.default);
    const n = parameters.stops.length;
    if (n === 1) return parameters.stops[0][1];
    if (input <= parameters.stops[0][0]) return parameters.stops[0][1];
    if (input >= parameters.stops[n - 1][0]) return parameters.stops[n - 1][1];

    const index = findStopLessThanOrEqualTo(parameters.stops, input);
    const process = getProcess(input, 1, parameters.stops[index][0], parameters.stops[index + 1][0]);

    const outputLower = parameters.stops[index][1];
    const outputUpper = parameters.stops[index + 1][1];

    return interColor(outputLower, outputUpper, process);
}

function evaluateIdentityFunction(parameters, input) {
    input = Color.parse(input);
    return coalesce(input, parameters.default);
}

/**
 * Returns the index of the last stop <= input, or 0 if it doesn't exist.
 *
 * @private
 */
function findStopLessThanOrEqualTo(stops, input) {
    const n = stops.length;
    let lowerIndex = 0;
    let upperIndex = n - 1;
    let currentIndex = 0;
    let currentValue, upperValue;

    while (lowerIndex <= upperIndex) {
        currentIndex = Math.floor((lowerIndex + upperIndex) / 2);
        currentValue = stops[currentIndex][0];
        upperValue = stops[currentIndex + 1][0];
        if (input === currentValue || (input > currentValue && input < upperValue)) {
            // Search complete
            return currentIndex;
        } else if (currentValue < input) {
            lowerIndex = currentIndex + 1;
        } else if (currentValue > input) {
            upperIndex = currentIndex - 1;
        }
    }

    return Math.max(currentIndex - 1, 0);
}

function coalesce(value, defaultValue) {
    return value || defaultValue || defaultColor;
}
function getProcess(input, base, lowerValue, upperValue) {
    const difference = upperValue - lowerValue;
    const progress = input - lowerValue;
    if (base === 1) {
        return progress / difference;
    } else {
        return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    }
}
function interpolate(a, b, t) {
    return a * (1 - t) + b * t;
}
function interColor(from, to, t) {
    return [
        interpolate(from[0], to[0], t),
        interpolate(from[1], to[1], t),
        interpolate(from[2], to[2], t),
        interpolate(from[3], to[3], t),
    ];
}
function oneOf(value, array, defaultValue) {
    return array.filter(v => v === value) ? value : defaultValue;
}
function isByteType(type) {
    return ["UNSIGNED_BYTE", "BYTE"].indexOf(type) > -1;
}
function isImgType(image) {
    return (
        image instanceof HTMLImageElement ||
        image instanceof HTMLCanvasElement ||
        image instanceof HTMLVideoElement ||
        image instanceof ImageData
    );
}

/**
 * @description obj è½¬åæ ç½ååæ°
 */
function queryString(obj) {
    return Object.keys(obj)
        .map((key: string) => {
            const value = obj[key];
            return `${key}=${value}`;
        })
        .join("&");
}

/**
 * @description éå®æ¶é´åè¿ç»­è§¦åæç»åªä¼è§¦åä¸æ¬¡
 */
function debounce(func, time) {
    let timerId = null;
    return () => {
        if (timerId) {
            clearTimeout(timerId);
            timerId = null;
        }
        timerId = setTimeout(func, time || 300);
    };
}

module.exports.handlePaint = handlePaint;
module.exports.defaultColor = defaultColor;
module.exports.scaleTypes = scaleTypes;
module.exports.defaultScale = defaultScale;
module.exports.parseColor = Color.parseLercColor;
module.exports.getColor = getColor;
module.exports.oneOf = oneOf;
module.exports.isByteType = isByteType;
module.exports.isImgType = isImgType;
module.exports.queryString = queryString;
module.exports.debounce = debounce;
